import Vue from 'vue'
import App from './index.vue'
import router from '@/router/lobsterCoupon'

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import 'amfe-flexible'

import '@/plugins/vant'
import '@/style/index.less'
import '@/style/flex.less'
import '@/style/config.less'
import '@/style/iconfont.css'

import { wxShare } from '@/plugins/utils'
import jrQrcode from "jr-qrcode"

Vue.config.productionTip = false
//定义全局环境变量
Vue.prototype.isInSmartCityApp = SmartCity.isSmartCityApp()
if (process.env.NODE_ENV === 'development') {
    Vue.prototype.isInSmartCityApp = true;
}

if (process.env.NODE_ENV !== 'production'  || window.location.href.indexOf('_debug=jsdev') > -1) {
    const VConsole = require('vconsole')
    new VConsole()
}

Vue.prototype.shareData = {
    title: '一起来钓龙虾！| 领石淙花海龙虾节消费券',
    brief: '',
    contentURL: 'https://prod-app-frontend.zhijianmedia.cn/activity-single-page/lobsterCoupon.html',
    imageLink:
        'http://oss2upload.oss-cn-hangzhou.aliyuncs.com/lobsterCoupon/userId_0_1653554056454_share-bg.jpg'
};

if (!Vue.prototype.isInSmartCityApp) {
    window.location.href = 'http://share.plus.hugd.com/app/jump/2022/lobsterCoupon'
}

//微信分享处理
if (!SmartCity.isSmartCityApp()) {
    wxShare('一起来钓龙虾！| 领石淙花海龙虾节消费券', 'http://oss2upload.oss-cn-hangzhou.aliyuncs.com/lobsterCoupon/userId_0_1653554056454_share-bg.jpg')
}

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
